var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.244,
    height: 14.812,
    viewBox: "0 0 15.244 14.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-heart",
    "data-name": "Icon ionic-ios-heart",
    d: "M13.784,3.937H13.75A3.9,3.9,0,0,0,10.5,5.718,3.9,3.9,0,0,0,7.244,3.937H7.21A3.871,3.871,0,0,0,3.375,7.807,8.335,8.335,0,0,0,5.012,12.35,28.682,28.682,0,0,0,10.5,17.634a28.682,28.682,0,0,0,5.485-5.283,8.335,8.335,0,0,0,1.637-4.544A3.871,3.871,0,0,0,13.784,3.937Z",
    transform: "translate(-2.875 -3.438)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartDark);
export default __webpack_public_path__ + "static/media/heart-dark.8b2a3c1db0ddf051170c980718571df3.svg";
export { ForwardRef as ReactComponent };